/**
 * Recently Viewed - fill a short row with greyed-out placeholders
 *
 * The RecentlyViewed component (RecentlyViewed-2a2cdf45.js) appends one card per
 * product the visitor has looked at and stops. A visitor two products in gets a
 * two-card row in a slot sized for four, which reads as a broken grid rather than
 * a short one. This file tops the row up with inert grey cards.
 *
 * WHY A SEPARATE, UNHASHED FILE: assets/ is bundler output whose source project is
 * not in this repo, so the component itself cannot be edited safely.
 *
 * COUNT comes from data-limit on <recently-viewed> (4). The attribute was
 * data-limie - a typo, so the component's own `limit` getter never saw it - now
 * corrected in sections/blocks-recently-viewed.liquid.
 *
 * ZERO IS LEFT ALONE. With no recently viewed products at all the component hides
 * the whole section, which is what Fallback Behavior is set to and what a first
 * time visitor should see: a row of four grey rectangles under a heading is worse
 * than no row. Say the word and this becomes a third Fallback Behavior option.
 *
 * ORDERING IS CSS, NOT DOM. The grid is a flex row, so placeholders take order: 1
 * and always trail the real cards however the component chooses to append them.
 * Reordering nodes here would fight the component and churn the observer.
 */
(function () {
  'use strict';

  var HOST = 'recently-viewed';
  var FEED = '[data-recently-viewed-element="feed"]';
  var PLACEHOLDER = 'recently-viewed__placeholder';
  var DEFAULT_LIMIT = 4;

  function limitFor(host) {
    var limit = parseInt(host.getAttribute('data-limit'), 10);
    return isNaN(limit) || limit < 1 ? DEFAULT_LIMIT : limit;
  }

  function build() {
    var item = document.createElement('div');
    item.className = 'product-card__item ' + PLACEHOLDER;
    item.setAttribute('aria-hidden', 'true');
    item.innerHTML =
      '<div class="' + PLACEHOLDER + '-media"></div>' +
      '<div class="' + PLACEHOLDER + '-line"></div>' +
      '<div class="' + PLACEHOLDER + '-line ' + PLACEHOLDER + '-line--short"></div>';
    return item;
  }

  function sync(host) {
    var feed = host.querySelector(FEED);
    if (!feed) return;

    var placeholders = [];
    var cards = 0;
    var child;

    for (var i = 0; i < feed.children.length; i++) {
      child = feed.children[i];
      if (child.classList.contains(PLACEHOLDER)) placeholders.push(child);
      else cards++;
    }

    // No products at all: the component hides the section, so leave it be.
    var wanted = cards === 0 ? 0 : Math.max(limitFor(host) - cards, 0);

    while (placeholders.length > wanted) feed.removeChild(placeholders.pop());
    for (var j = placeholders.length; j < wanted; j++) feed.appendChild(build());
  }

  function watch(host) {
    var feed = host.querySelector(FEED);
    if (!feed) return;

    sync(host);

    // Adding or removing a placeholder mutates the feed and re-enters this, which
    // is fine: the second pass finds the count already correct and changes nothing.
    new MutationObserver(function () {
      sync(host);
    }).observe(feed, { childList: true });
  }

  function start() {
    var hosts = document.querySelectorAll(HOST);
    for (var i = 0; i < hosts.length; i++) watch(hosts[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
